import { createContext } from 'react';

export interface PolicyNoticeContextValue {
  /** 確認を待っている改定があるか */
  hasPending: boolean;
  /** 改定の告知を開く（AI アシスタントの入口などから） */
  openNotice: () => void;
}

export const PolicyNoticeContext = createContext<PolicyNoticeContextValue>({
  hasPending: false,
  openNotice: () => undefined,
});
